import { render, staticRenderFns } from "./RiskPolicies.vue?vue&type=template&id=805cf492"
import script from "./RiskPolicies.vue?vue&type=script&lang=js"
export * from "./RiskPolicies.vue?vue&type=script&lang=js"
import style0 from "./RiskPolicies.vue?vue&type=style&index=0&id=805cf492&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports